<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('instanceManage.page.TransactionInstance')" prop="sagaCode">
            <BjInput v-model="queryParams.sagaCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('instanceManage.page.Status')" prop="status">
            <el-select v-model="queryParams.status" class="full-width" :placeholder="$t('chooseText')" clearable>
              <el-option v-for="(item, index) in INSTANCE_RESULT_TYPE_LIST" :key="index" :label="$t(item.label)" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('instanceManage.page.businessType')" prop="refType">
            <BjInput v-model="queryParams.refType" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('instanceManage.page.businessID')" prop="refId">
            <BjInput v-model="queryParams.refId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('dateText')">
            <BjDateRangePicker v-model="queryParamsTime_saga" :placeholder="$t('dateText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop === 'refId'">
            <template slot-scope="scope">
              <el-link v-if="col.prop === 'sagaCode'" type="primary" :underline="false" @click="showDrawer(scope.row)">
                {{ scope.row[col.prop] }}
              </el-link>
              <span v-else-if="col.prop === 'status'">
                <el-tag :type="
                    scope.row.status === 'RUNNING'
                      ? 'success'
                      : scope.row.status === 'FAILED'
                      ? 'danger'
                      : scope.row.status === 'COMPLETED'
                      ? 'info'
                      : scope.row.status === 'NON_CONSUMER'
                      ? 'success'
                      : scope.row.status === 'WAIT_TO_BE_PULLED'
                      ? 'success'
                      : ''
                  ">{{ $t(INSTANCE_RESULT_TYPE_LIST.bjGet(scope.row.status)) }}</el-tag>
              </span>
              <el-tooltip v-else-if="col.prop === 'completedCount'" placement="top">
                <div slot="content">
                  <div>{{ $t('instanceManage.page.Done') }}：{{ scope.row.completedCount }}</div>
                  <div>{{ $t('instanceManage.page.Failed') }}：{{ scope.row.failedCount }}</div>
                  <div>{{ $t('instanceManage.page.InProgress') }}：{{ scope.row.runningCount }}</div>
                  <div>{{ $t('instanceManage.page.WaitingPulled') }}：{{ scope.row.waitToBePulledCount }}</div>
                </div>
                <el-button>{{ $t('viewText') }}</el-button>
                <el-progress v-if="scope.row.status === 'COMPLETED'" :percentage="0" :show-text="false" />
                <el-progress v-if="scope.row.status === 'FAILED'" :percentage="100" status="exception" :show-text="false" />
                <el-progress v-if="
                    scope.row.status === 'RUNNING' ||
                    scope.row.status === 'NON_CONSUMER' ||
                    scope.row.status === 'WAIT_TO_BE_PULLED'
                  " :percentage="10" :show-text="false" />
              </el-tooltip>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-drawer size="80%" :visible.sync="drawer" direction="rtl" destroy-on-close :before-close="handleClose">
      <instance-detail :data="details" :type-list="INSTANCE_RESULT_TYPE_LIST" @resetData="onResetData" />
    </el-drawer>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi } from '@/api';
import { INSTANCE_RESULT_TYPE_LIST } from '@/utils/constants';
import instanceDetail from '../components/instance-detail';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'SettingInstanceManage',
  components: {
    instanceDetail,
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      INSTANCE_RESULT_TYPE_LIST,
      queryApi: settingApi.getInstancesList,
      // 查询参数
      queryParamsTime_saga: [],
      queryParams: {
        searchId: null,
        sagaCode: null,
        status: null,
        refType: null,
        refId: null,
        startDate: null,
        endDate: null,
      },
      drawer: false,
      details: {},
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        { label: 'instanceManage.table.TransactionInstance', prop: 'sagaCode', isCheck: true, disabled: false, width: 180 },
        { label: 'instanceManage.table.TransactionDescription', prop: 'description', isCheck: true, disabled: false, width: 180 },
        { label: 'instanceManage.table.Status', prop: 'status', isCheck: true, disabled: false, width: 80 },
        { label: 'instanceManage.table.ProgressBar', prop: 'completedCount', isCheck: true, disabled: false, width: 200 },
        { label: 'instanceManage.table.StartTime', prop: 'startTime', isCheck: true, disabled: false, width: 135 },
        { label: 'instanceManage.table.businessType', prop: 'refType', isCheck: true, disabled: false, width: 110 },
        { label: 'instanceManage.table.businessID', prop: 'refId', isCheck: true, disabled: false },
      ],
    };
  },
  computed: {},
  watch: {
    queryParamsTime_saga(v) {
      this.queryParams.startDate = (v || [])[0];
      this.queryParams.endDate = (v || [])[1];
    },
  },
  mounted() {},
  methods: {
    showDrawer(row) {
      settingApi.getInstancesDetail({ id: row.id }).then(res => {
        this.details = res;
        this.drawer = true;
      });
    },
    onResetData(id) {
      settingApi.getInstancesDetail({ id: id }).then(res => {
        this.details = res;
      });
    },
    handleClose(done) {
      done();
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_saga = [];
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  overflow: auto;
  padding: 30px;
}
</style>
